import { render, staticRenderFns } from "./MenuNav.vue?vue&type=template&id=0b386c2d&scoped=true&"
import script from "./MenuNav.vue?vue&type=script&lang=js&"
export * from "./MenuNav.vue?vue&type=script&lang=js&"
import style0 from "./MenuNav.vue?vue&type=style&index=0&id=0b386c2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b386c2d",
  null
  
)

export default component.exports